module.exports = __webpack_public_path__ + "img/Transtreams.083b4867.jpg";